import { isArray } from 'util';
import { getAlbumNodes, Curation } from '../functions/AlbumAPIs.js';
import { checkAcl, checkMultiCampus, getMultiCampuslist } from "../../adminressources/ACLHelper.js";
import { getToken, getLogin, getView, Check_login_ticket } from './helper.js';
import { MyBin, cleanTrashcan, loadTrashcan } from './Trashcan.js';
import { Field_Info, config as getConfig } from './Config.js';

// Initial state of Advance Query
export const defaultAdvanced = {
    and: true,
    field: "",
    field_selected: false,
    op: "~=",
    value: ""
}

// initial State of the Query object
export const initialState = {
    advanced_query: [{ ...defaultAdvanced }],
};

export var Query = initialState;

// Loads the config from the server
export function updateQuery(query) {
    Query = query
}
// Sets the default facet limit to 1000
export const FACET_LIMIT = 1000;

export var FacetData = undefined;
export var AllFacetData = undefined;
// const query_pattern = /([\!\*\+\-\=\<\>\&\|\(\)\[\]\{\}\^\~\?\:\\/"])/g;
const query_pattern = /([!*+-=<>&|()[]{}^~?:\/"])/g;
// Sets the default number of facet values per request
export const DEFAULT_FACET_PAGE_SIZE = 25;
// tracks per-facet offsets for incremental loading
export var facetOffsets = {};
let latestFacetRefreshRequestId = 0;
const HIDDEN_ADMIN_STATUS_VALUES = new Set(["Profile", "Reference Point"]);

const sanitizeFacetBuckets = (facetName, buckets = []) => {
    if (facetName !== "sb_adminStatus") {
        return buckets;
    }

    return buckets.filter(bucket => !HIDDEN_ADMIN_STATUS_VALUES.has(bucket?.val));
};

// Sanitise Query method for removing and changing query to yaml readable
export const sanitiseQuery = (query) => {
    let q = String(query);
    return q.replace(query_pattern, "\\$1");
}

// returns the suggested Query fields and query fields used by solr
export const getQueryFields = (config, info) => {

    let returnFields = "suggest^10";

    let result_view_fields = config?.result_views.map(view => {

        let fields = [];

        fields = fields.concat(view.heading);

        if (view.sub_heading !== undefined && view.sub_heading !== null) {
            fields = fields.concat(view.sub_heading);
        }

        if (view.first_row !== undefined && view.first_row !== null) {
            fields = fields.concat(view.first_row);
        }

        if (view.second_row !== undefined && view.second_row !== null) {
            fields = fields.concat(view.second_row);
        }


        return fields;
    }).reduce((a, b) => a.concat(b), []);

    result_view_fields = result_view_fields.filter(field => info.fields[field] !== undefined && info.fields[field] !== null && info.fields[field].type === "text").map(field => field + "_q");


    returnFields += " " + result_view_fields.join(" ");

    if (config.suggest_field !== undefined && config.suggest_field !== null) {
        returnFields += " " + config.suggest_field;
    }


    return returnFields;
}

const PERSON_TAG_FIELDS = ["sb_student", "sb_staff", "sb_pastStudent", "sb_visitor"];

const buildContainsQuery = (field, value) =>
    `${field}:*${String(value ?? "").replace(/\s/g, "\\ ")}*`;

const buildEqualityQuery = (field, value) => {
    const stringValue = String(value ?? "");

    return stringValue.indexOf("*") !== -1
        ? `${field}:${stringValue}`
        : `${field}:"${stringValue}"`;
};

const buildMultiFieldQuery = (fieldNames, row) => {
    const clauses = fieldNames.map((fieldName) => {
        switch (row.op) {
            case "~=":
                return buildContainsQuery(fieldName, row.value);
            case "==":
            case "!=":
                return buildEqualityQuery(fieldName, row.value);
            default:
                return "";
        }
    }).filter(Boolean);

    if (clauses.length === 0) {
        return "";
    }

    if (row.op === "!=") {
        return `(*:* NOT (${clauses.join(" OR ")}))`;
    }

    return `(${clauses.join(" OR ")})`;
};

const mapProfileTypeToMediaField = (value) => {
    const normalizedValue = String(value ?? "")
        .trim()
        .toLowerCase()
        .replace(/[-_\s]+/g, " ");

    const fieldMap = {
        student: "sb_student",
        students: "sb_student",
        staff: "sb_staff",
        visitor: "sb_visitor",
        visitors: "sb_visitor",
        "past student": "sb_pastStudent",
        "past students": "sb_pastStudent",
    };

    return fieldMap[normalizedValue] || null;
};

const buildProfileTypeMediaQuery = (row) => {
    const normalizedValue = String(row?.value ?? "")
        .trim()
        .toLowerCase()
        .replace(/[-_\s]+/g, " ");

    if (normalizedValue === "student" || normalizedValue === "students") {
        const studentPresenceQuery =
            "(sb_student:* AND (sb_studentYearLevel:* OR sb_studentBoarder:* OR sb_studentSubSchool:*))";

        if (row.op === "==") {
            return studentPresenceQuery;
        }

        if (row.op === "!=") {
            return `(*:* NOT ${studentPresenceQuery})`;
        }

        return "";
    }

    const mappedField = mapProfileTypeToMediaField(row?.value);

    if (!mappedField) {
        return "";
    }

    if (row.op === "==") {
        return `${mappedField}:*`;
    }

    if (row.op === "!=") {
        return `(*:* NOT ${mappedField}:*)`;
    }

    return "";
};

export const convertToLucence = (query, fields) => {
    // For each row (used for advance) returns a solr readable query from user input
    return query.filter(row => row.value !== "" && row.field_selected === true)
        .map((row) => {
            let return_row = { ...row };
            // Converts the date to ISO string if the value is a date
            if (fields[row.field] !== null && fields[row.field].type === "date" && (row.op === ">=" || row.op === "<=")) {
                let date_value = row.value;
                try {
                    return_row.value = date_value
                } catch {
                    return_row.value = ""
                }
            }


            return return_row
        })
        .filter(row => row.value !== "")
        .map((row, index) => {
            let return_query = "";

            if (index > 0) {
                return_query += row.and ? "AND " : "OR ";
            }

            let type = getType(fields[row.field]);

            if (row.field === "sb_profileName") {
                return return_query + buildMultiFieldQuery(PERSON_TAG_FIELDS, row);
            }

            if (row.field === "sb_profileType") {
                const profileTypeQuery = buildProfileTypeMediaQuery(row);

                if (profileTypeQuery) {
                    return return_query + profileTypeQuery;
                }
            }

            // Depending on the operator used, will create the query
            if (row.field !== undefined && row.value !== undefined && row.field !== null && row.value !== null) {
                switch (row.op) {
                    default:
                        break;
                    case "~=":

                        if (type === "text" && row.field !== "path_starts_with" && row.field !== "path") {
                            return_query += `${row.field}:*${row.value.replace(/\s/g, "\\ ")}*`
                        } else {
                            return_query += `${row.field}:*${row.value.replace(/\s/g, "\\ ")}*`
                        }
                        break;

                    case "==":
                        if (row.value === "*" && type === "number") {
                            row.value = "[* TO *]";
                        }
                        try {
                            return_query += row.value.indexOf("*") !== -1 ? `${row.field}:${row.value}` : `${row.field}:"${row.value}"`
                        } catch {
                            return_query += `${row.field}:${row.value}`
                        }
                        break;

                    case "!=":

                        if (row.value === "*" && (type === "number" || type === "long")) {
                            row.value = "[* TO *]";
                        }

                        //Solr automatically expands -field:* to (*:* NOT field:*) but ONLY for the first statement... 
                        return_query += row.value.indexOf("*") !== -1 ? `(*:* NOT ${row.field}:${row.value})` : `(*:* NOT ${row.field}:"${row.value}")`
                        break;

                    case ">=":
                        return_query += `${row.field}:[${row.value} TO *]`
                        break;

                    case "<=":
                        return_query += `${row.field}:[* TO ${row.value}]`
                        break;
                }
            }
            return return_query;
        })
        .join(" ");
}

// allowed operator types
export const allowed_types = {
    text: ['~=', '==', '!='],
    select: ['==', '!='],
    boolean: ['=='],
    date: ['>=', '<='],
    number: ['==', '!=', '>=', '<=']
};

// labels for each operator types
export const allowed_types_selector = {
    text: [{ label: "Contains", value: '~=' }, { label: "Equals", value: '==' }, { label: "Does Not Equal", value: '!=' }],
    select: [{ label: "Equal", value: '==' }, { label: "Not Equal", value: '!=' }],
    boolean: [{ label: "Equal", value: '==' }],
    date: [{ label: "Greater Than or Equal To", value: '>=' }, { label: "Less Than or Equal To", value: '<=' }],
    number: [{ label: "Equals", value: '==' }, { label: "Not Equal", value: '!=' }, { label: "Greater Than or Equal To", value: '>=' }, { label: "Less than or Equal To", value: '<=' }]
};

// Gets the type of field and returns the type matched in alfresco
export const getType = (info) => {
    let field_type = "text";
    if (info !== undefined && info !== null) {
        if (info.constraints && info.constraints.list) {
            field_type = "select";
        } else if (info.type === "path") {
            field_type = "text";
        } else if (info.type === "boolean") {
            field_type = "boolean";
        } else if (info.type === "double" || info.type === "long" || info.type === "int") {
            field_type = "number";
        } else if (info.type === "date") {
            field_type = "date";
        }
    }

    return field_type;
}

// convert filters to string query
export const filterToString = (filter, fields) => {
    let val;

    let join = " OR ";

    if (filter.type !== undefined && filter.type !== null) {
        join = " " + filter.type + " ";
    }

    // Skip sanitisation rules if field type is "date" or field name is "id"
    if ((fields[filter.field_name] !== undefined && fields[filter.field_name].type === "date") || filter.field_name === "id" || (filter.value.length > 0 && filter.value[0] === ".*")) {
        if (filter.value !== undefined && filter.value !== null) {
            val = `(${filter.value.join(join)})`;
        }

    } else {
        val = `(${filter.value.map(val => `"${sanitiseQuery(val)}"`).join(join)})`;
    }

    return `{!tag=${filter.field_name}}${filter.inverse ? "-" : "+"}${filter.field_name}:${val}`;

}

// Initial field list
export const fieldList = (fields) => {
    return Object.keys(fields).concat(["id", "type", "path", "cm_name", "preview_ref", "preview_kind", "preview_type", "sb_tags", "sb_publisedTo"]);
}

export async function submitSolrQuery(type, selectedRows, id, resolution, albumNodes, albumFilters, uploadedNodes) {
    // Trashcan sync is needed for initial loads (to exclude trashed items),
    // but doing it on every paginated scroll request is expensive.
    // We treat requests where `selectedRows` advances beyond one page as pagination.
    const PAGE_SIZE = ["filter", "query", "album", "classify", "advanced"].includes(type) ? 50 : 200;
    const isPaginationRequest =
        selectedRows !== undefined &&
        selectedRows !== null &&
        type !== "upload" &&
        type !== "tag" &&
        selectedRows > PAGE_SIZE;

    if (!isPaginationRequest) {
        await cleanTrashcan();
        await loadTrashcan();
    }
    // Updates suggestive search everytime a query is applied
    if (!getConfig?.suggestions) {
        updateSearchSuggestions();
    }
    // Loads all the config, info and currenty query
    let config = getConfig;
    let view = getView();

    //remove filters if it is albums
    if (albumNodes !== undefined && ["classify", "album"].includes(type)) {
        view.filters = []
    }

    // loads the nodes that are within the bin
    let bin = [...MyBin]

    // if not accessing upload, bin or curation. Will add the curation and bin nodes to a filter to ignore them on lookup
    let curation = []
    if (type === undefined || type === null || !["bin", "classify", "upload", "album"].includes(type)) {
        const albumNodes = await getAlbumNodes(1);
        if (albumNodes) {
            albumNodes?.forEach(doc => curation.push(doc));
        }
    }

    let bin_and_curation = [...bin, ...curation]

    // if accessing the bin, does a search on only the bin nodes
    if (type === "bin" && bin_and_curation.length > 0) {
        view.filters = []
        view.filters.push({ field_name: "id", value: bin_and_curation, inverse: false })
    } else if (type === "upload" && uploadedNodes.length > 0) {
        view.filters = []
        view.filters.push({ field_name: "id", value: [...uploadedNodes], inverse: false })
    }

    // Add a solr filter if its a bin list
    if (!["bin", "classify", "upload", "album", "collection"].includes(type) && bin_and_curation.length > 0) {
        view.filters.push({ field_name: "id", value: bin_and_curation, inverse: true });
    }

    let info = Field_Info;

    // Loads the current saved query
    let current_q = Query;
    if (current_q === undefined || current_q === null) {
        current_q = initialState
    }

    // adds the field lists into the URL
    let fl = encodeURIComponent(fieldList(info.fields).join(","));

    // Gets the Solr query info
    let query = view.query;
    let q = query === "" ? "*:*" : query.indexOf(":") !== -1 ? query : sanitiseQuery(query);
    // excludes bin items
    if (id !== undefined && id !== null) {
        q = "id:(" + id + ")";
    }

    if (!["collection", "classify", "album", "filter", "upload"].includes(type)) {
        getFacets(true, q, config, type, bin_and_curation);
    }

    let filters = ["album", "classify"].includes(type) ? [] : [config.default_filter];

    let applied_filter_rules = [];

    let filter_rules = view.filter_rules || [];

    filter_rules.forEach(filter_rule => {
        if (config.filter_rules[filter_rule] !== undefined && config.filter_rules[filter_rule] !== null) {
            applied_filter_rules.push(config.filter_rules[filter_rule]);
        }
    });

    let sort = ""
    if (view.sort.field === "exif_pixelXDimension") { // Use for resolution sorting
        sort = "mul(exif_pixelXDimension,exif_pixelYDimension) " + view.sort.direction;
    } else {
        sort = view.sort.field + " " + view.sort.direction;
    }

    let rows;
    // 50-row pages for filter/query/album/classify
    if (["filter", "query", "album", "classify", "advanced"].includes(type)) {
        rows = 50;
    }
    else {
        rows = 200;
    }
    if (selectedRows !== undefined && selectedRows !== null) {
        rows = selectedRows;
    }


    // Sets the amount of rows by default for bin and event
    if (type === "event" || type === "bin") {
        rows = 100000;
    }

    let fields_info = info.fields;
    let query_facets = view.facets;

    // Creates the facet query based on the facets added.
    let facets = query_facets.filter(facet => fields_info[facet] !== undefined).filter(facet => fields_info[facet].type !== "date");

    let date_type_fields = query_facets.filter(facet => fields_info[facet] !== undefined).filter(facet => fields_info[facet].type === "date");


    // let facet_query_field = date_type_fields.map(encodeURIComponent).map(field =>
    //     [field + ":[NOW-1DAY TO NOW]", field + ":[NOW-7DAYS TO NOW]", field + ":[NOW-1MONTH TO NOW]", field + ":[NOW-1YEAR TO NOW]", field + ":[* TO NOW-1YEAR]"].map(query => `facet.query={!ex=${field}}${query}`).join("&")
    // ).join("&");

    let facet_query_field = date_type_fields.flatMap(field => {
        let encodedField = encodeURIComponent(field);
        return [
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1DAY TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-7DAYS TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1MONTH TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1YEAR TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[* TO NOW-1YEAR]`
        ];
    }).join("&");

    if (type === "album" || type === "classify") {
        facets = query_facets.filter(facet => fields_info[facet] !== undefined);
        //Here is to add missing facet field for albums on the config.yml
        if (!facets.includes("exif_dateTimeOriginal")) {
            facets.push("exif_dateTimeOriginal")
        }
        date_type_fields = query_facets.filter(facet => fields_info[facet] !== undefined);
        facet_query_field = ""

        if (albumNodes === undefined || albumNodes === null || albumNodes?.length === 0) {
            filters = []
        } else {
            let album_filter = [{ field_name: "id", value: albumNodes, inverse: false }]
            let filtered_rules = applied_filter_rules;
            if (["album", "classify"].includes(type)) {
                filtered_rules = filtered_rules.filter(f => {
                    if (typeof f === 'string') {
                        return !f.includes('sb_adminStatus:("Profile")');
                    }
                    if (f && f.field_name === 'sb_adminStatus' && Array.isArray(f.value) && f.value.includes('Profile')) {
                        return false;
                    }
                    return true;
                });
            }

            filters = filters.concat(album_filter
                .filter(filter => filter.field_name !== "Advanced" && filter.value.length > 0)
                .map(filter => filterToString(filter, info.fields)).concat(filtered_rules.map(filter => filterToString(filter, info.fields))));
            if (albumFilters && albumFilters.length > 0) {
                filters = [...filters, ...albumFilters]
            }
        }
    } else {
        filters = filters.concat(view.filters
            .filter(filter => filter.field_name !== "Advanced" && filter.value.length > 0)
            .map(filter => filterToString(filter, info.fields)).concat(applied_filter_rules.map(filter => filterToString(filter, info.fields))));
    }

    let facetOptions = "facet.limit=" + (FACET_LIMIT + 1);

    // Update filter to the advanced parameters
    filters = filters.concat(view.filters.filter(filter => filter.field_name === "Advanced").map(filter => isArray(filter.value) ? filter.value.join(" ") : filter.value));

    // Options of setting path starts with
    if (facets.indexOf("path_starts_with") !== -1) {
        let facet_field = view.filters.find(filter => filter.field_name === "path_starts_with");

        let prefix = facet_field !== undefined ? (isArray(facet_field.value) ? facet_field.value.join(" ") : facet_field.value) : config.path_strip;

        facetOptions += "&f.path_starts_with.facet.limit=1000";
        facetOptions += "&f.path_starts_with.facet.mincount=0";
        facetOptions += "&f.path_starts_with.facet.sort=index";
        facetOptions += "&f.path_starts_with.facet.prefix=" + encodeURIComponent(prefix);
    }

    let token = getToken();

    let headers = { 'Content-Type': 'application/json', "Semabench-Token": token, "Cache-Control": "max-age=0" };

    let qf = encodeURIComponent(getQueryFields(config, info));
    let facet = {};

    facets.forEach(val => {

        let limit = FACET_LIMIT + 1;
        facet[val] = {
            type: "terms",
            field: val,
            sort: val === "sb_year" ? "index desc" : undefined,
            domain: {
                excludeTags: val
            },
            limit,
        }
    })

    facet_query_field = facet_query_field === "" ? "" : "&" + facet_query_field;

    if (type === "upload") {
        q = "*:*";
    }

    //applying solr query based on the identified campus
    let login = getLogin();
    if (login !== undefined && login !== null) {

        if (!checkAcl(login.roles, config.acls, "ADMIN") && type !== "album" && type !== "favourite" && type !== "upload" && type !== "collection") {
            // update the solr query
            if (checkMultiCampus()) {
                let campus = getMultiCampuslist();

                //create new query with uploaderCampus and update the query
                let new_q = "";
                for (let y = 0; y < campus.length; y++) {
                    let part = `sb_uploaderCampus:"${campus[y]}" OR sb_studentCampus:"${campus[y]}"`;
                    if (y + 1 === campus.length) {
                        new_q += part;
                    } else {
                        new_q += part + " OR ";
                    }
                }

                if (q === "" || q === undefined || q === null || q === "*:*") {
                    q = new_q
                } else {
                    q += " AND (" + new_q + ")"
                }
            }
        }
    }

    let body = JSON.stringify({
        query: q,
        filter: filters,
        facet: facet
    })

    // Added a start index. More you scroll it creates a offset so the API only ever get 200 items at a time


    let selected = 0;
    if (selectedRows !== undefined && selectedRows !== null && type !== "upload") {
        if (["filter", "query", "album", "classify", "advanced"].includes(type)) {
            const PAGE_SIZE = 50;
            selected = selectedRows - PAGE_SIZE;
            rows = PAGE_SIZE;
        } else {
            const PAGE_SIZE = 200;
            selected = selectedRows - PAGE_SIZE;
            rows = PAGE_SIZE;
        }
    }

    if (type === "upload") {
        rows = selectedRows
    }

    if (selected < 0) {
        selected = 0;
    }

    let wt = "json"
    if ("tag" === type) {
        selected = 0;
        rows = 100000;
        fl = "%2Ccm_name%2Csb_event%2Csb_studentCampus%2Csb_tags%2Csb_term%2Csb_week%2Csb_year%2Ccm_description"
        wt = "csv"
    }


    let result = await fetch(`../api/v1/repo/s/semabench/query?q=*:*&q.op=AND&omitHeader=true&defType=edismax&wt=${wt}&qf=${qf}&pf=${qf}&start=${selected}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&sort=${sort}&fl=${fl}&rows=${rows}&facet=true&facet.mincount=1&${facetOptions}` + facet_query_field, {
        method: "POST",
        headers,
        body
    }).catch(error => {
        // toaster.push(<Message type='error' showIcon closable>{error}</Message>);
    })

    if (!result) {
        return null;
    }

    //redirect the users to the login pages if the login token is invalid
    if (result.status === 401) {
        await Check_login_ticket()
        return null;
    }

    if ("tag" === type) {
        return await result.text().then(async resp => {
            return await loadingFields(resp, type);
        })
    }
    else {

        return await result.json().then(async resp => {
            return await loadingFields(resp, type);
        })
    }
}

//load one image
export const loadDocs = async (id) => {

    let token = getToken();

    let headers = { 'Content-Type': 'application/json', "Semabench-Token": token, "Cache-Control": "max-age=0" };

    let query = { query: 'id:' + id }

    return await fetch('../api/v1/repo/s/semabench/query?q=*:*', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(query)
    }).then(resp => resp.json())
        .then(response => {
            return response?.response
        })
}

// Does a query search to get all the facets, regardless of 200 to fill out search drop downs
// Filter by campus correctly
export async function getFacetsOriginal(upload, filterQuery, qconfig, type, bin_and_curation) {
    let config = getConfig;

    // IMPORTANT: never mutate the persisted view object in getFacets
    const rawView = getView() || {};
    const view = {
        ...rawView,
        filters: Array.isArray(rawView.filters) ? [...rawView.filters] : [],
        facets: Array.isArray(rawView.facets) ? [...rawView.facets] : [],
        filter_rules: Array.isArray(rawView.filter_rules) ? [...rawView.filter_rules] : [],
    };

    if (qconfig !== undefined && qconfig !== null) {
        if (type !== undefined && type !== null) {
            if (type !== "classify") {
                config = qconfig;
            }
        }
    }

    // Build a local excluded-id list (bin + curation) WITHOUT mutating view.filters
    let excludedIds = [];
    if (Array.isArray(bin_and_curation) && bin_and_curation.length > 0) {
        excludedIds = [...bin_and_curation].filter(Boolean);
    } else {
        // loads the nodes that are within the bin
        const bin = Array.isArray(MyBin) ? [...MyBin] : [];
        const curation = Array.isArray(Curation) ? [...Curation] : [];

        if ((type === undefined || type === null || !["bin", "classify", "upload", "album"].includes(type)) && curation.length === 0) {
            const albumNodes = await getAlbumNodes(1);
            if (albumNodes) {
                albumNodes.forEach(doc => curation.push(doc));
            }
        }

        excludedIds = [...bin, ...curation].filter(Boolean);
    }

    const info = Field_Info;
    const fields_info = info.fields;

    const facet = {};
    const token = getToken();

    const headers = {
        'Content-Type': 'application/json',
        "Semabench-Token": token,
        "Cache-Control": "max-age=0"
    };

    // Base query: use view.query unless an explicit filterQuery is provided
    const query = view.query;
    let baseQ = query === "" ? "*:*" : (query.indexOf(":") !== -1 ? query : sanitiseQuery(query));
    let q = (filterQuery && filterQuery !== "") ? filterQuery : baseQ;

    // CAMPUS FILTERING
    let login = getLogin();
    let campusFilteringActive = false;
    let campusFilters = "";

    if (login !== undefined && login !== null) {

        const isNonAdmin = !checkAcl(login.roles, config.acls, "ADMIN");
        const allowCampusFilter = type !== "album" && type !== "favourite" && type !== "upload";

        if (isNonAdmin && allowCampusFilter && checkMultiCampus()) {
            campusFilteringActive = true;
            const campus = getMultiCampuslist();
            campusFilters = campus
                .map(c => `sb_uploaderCampus:"${c}" OR sb_studentCampus:"${c}"`)
                .join(" OR ");

            // Append campus clause; NEVER overwrite the existing query
            if (!q || q === "*:*" || q === "*") {
                q = `(${campusFilters})`;
            } else {
                q = `(${q}) AND (${campusFilters})`;
            }
        }
    }

    const query_facets = view.facets;

    const facets = query_facets
        .filter(f => fields_info[f] !== undefined)
        .filter(f => fields_info[f].type !== "date");

    const date_type_fields = query_facets
        .filter(f => fields_info[f] !== undefined)
        .filter(f => f === "cm_created" && fields_info[f].type === "date");

    let facet_query_field = date_type_fields.flatMap(field => {
        let encodedField = encodeURIComponent(field);
        return [
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1DAY TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-7DAYS TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1MONTH TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1YEAR TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[* TO NOW-1YEAR]`
        ];
    }).join("&");

    facets.forEach(val => {
        const limit = FACET_LIMIT + 1;
        facet[val] = {
            type: "terms",
            field: val,
            sort: val === "sb_year" ? "index desc" : "index asc",
            domain: {
                excludeTags: val
            },
            limit,
        };
    });

    // Build filters WITHOUT mutating view.filters
    let filters = [config.default_filter];

    const applied_filter_rules = [];
    const filter_rules = view.filter_rules || [];

    filter_rules.forEach(filter_rule => {
        if (config?.filter_rules?.[filter_rule]) {
            applied_filter_rules.push(config.filter_rules[filter_rule]);
        }
    });

    // Add the excluded id filter locally (same semantic as before) but without persisting it
    const viewFiltersForFacet = Array.isArray(view.filters) ? [...view.filters] : [];
    if (Array.isArray(excludedIds) && excludedIds.length > 0) {
        viewFiltersForFacet.push({ field_name: "id", value: excludedIds, inverse: true });
    }

    filters = filters.concat(
        viewFiltersForFacet
            .filter(filter => filter.field_name !== "Advanced")
            .map(filter => filterToString(filter, info.fields))
            .concat(applied_filter_rules.map(filter => filterToString(filter, info.fields)))
    );

    filters = filters.concat(
        viewFiltersForFacet
            .filter(filter => filter.field_name === "Advanced")
            .map(filter => isArray(filter.value) ? filter.value.join(" ") : filter.value)
    );

    const qf = encodeURIComponent(getQueryFields(config, info));

    let facetResp = {};
    facet_query_field = facet_query_field === "" ? "" : "&" + facet_query_field;

    // PRIMARY QUERY: facets constrained exactly like the gallery query (including default_filter + rules + id exclusions)
    const body = JSON.stringify({
        query: q,
        filter: filters,
        facet: facet
    });

    await fetch(`../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map${facet_query_field}`, {
        method: 'POST',
        headers: headers,
        body: body
    }).then(resp => resp.json())
        .then(response => {
            if (response.facet_counts) {
                if (response.facet_counts.facet_fields) {
                    facetResp = response.facet_counts.facet_fields;
                }

                if (response.facet_counts.facet_queries) {
                    const facet_queries = response.facet_counts.facet_queries;
                    Object.keys(facet_queries)
                        .filter(facet_query => facet_query.indexOf(":") > 0)
                        .forEach(facet_query => {
                            const splits = facet_query.split(":");
                            const facet_field_parts = splits[0];
                            const facet_field = facet_field_parts.replace(/{!ex=[^}]+}/g, "");
                            const val = splits[1];
                            const count = facet_queries[facet_query];

                            if (!facetResp[facet_field]) {
                                facetResp[facet_field] = [];
                            }

                            if (!HIDDEN_ADMIN_STATUS_VALUES.has(val) || facet_field !== "sb_adminStatus") {
                                facetResp[facet_field].push({ val, count });
                            }
                        });
                }
            }

            if (response.facets) {
                const facet_resp = response.facets;
                Object.keys(facet_resp).filter(val => val !== "count")
                    .forEach(facet_field => {
                        const f = facet_resp[facet_field];

                        if (!facetResp[facet_field]) {
                            facetResp[facet_field] = [];
                        }

                        f.buckets.forEach((bucket) => {
                            facetResp[facet_field].push({
                                val: bucket.val + "",
                                count: bucket.count
                            });
                        });
                    });
            }
        });

    // SECOND QUERY: widen facet value list WITHOUT introducing hidden/system files.
    // We keep default_filter + rules + id exclusions, and (if multi-campus) the same campus restriction.
    const qAll = campusFilteringActive && campusFilters
        ? `(${campusFilters})`
        : "*:*";

    const baseOnlyFilters = [config.default_filter]
        .concat(applied_filter_rules.map(filter => filterToString(filter, info.fields)));

    // include id exclusions in the base-only pass as well
    if (Array.isArray(excludedIds) && excludedIds.length > 0) {
        baseOnlyFilters.push(filterToString({ field_name: "id", value: excludedIds, inverse: true }, info.fields));
    }

    await fetch(`../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map${facet_query_field}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            query: qAll,
            filter: baseOnlyFilters,
            facet: facet
        })
    }).then(resp => resp.json())
        .then(response => {
            if (response.facets) {
                const unfiltered_facets = response.facets;
                Object.keys(unfiltered_facets).filter(val => val !== "count")
                    .forEach(facet_field => {
                        const f = unfiltered_facets[facet_field];
                        const existing = facetResp[facet_field] || [];
                        const existingVals = new Set(existing.map(item => item.val));

                        sanitizeFacetBuckets(facet_field, f.buckets.map((bucket) => ({
                            val: bucket.val + "",
                            count: bucket.count
                        }))).forEach((bucket) => {
                            const v = bucket.val;
                            if (!existingVals.has(v)) {
                                existing.push({
                                    val: v,
                                    count: bucket.count
                                });
                            }
                        });

                        facetResp[facet_field] = existing;
                    });
            }
        });

    if (Object.keys(facetResp).length !== 0) {
        FacetData = facetResp;
    }
}

// Fixed facet.query
export async function getFacets(
    upload,
    filterQuery,
    qconfig,
    type,
    bin_and_curation,
    facetPageSize = DEFAULT_FACET_PAGE_SIZE,
    facetOffsetsParam = {}
) {
    const facetRefreshRequestId = ++latestFacetRefreshRequestId;

    // A full facet refresh invalidates any paged offsets from the previous query.
    facetOffsets = {};

    const {
        q,
        filters,
        headers,
        qf,
        facets,
        facetQueryString,
        campusFilteringActive
    } = await buildFilteredFacetRequestContext({
        filterQuery,
        qconfig,
        type,
        bin_and_curation,
        facetPageSize,
        facetOffsetsParam
    });

    facetOffsets = Object.keys(facets).reduce((acc, field) => {
        acc[field] = facetPageSize;
        return acc;
    }, {});

    // ----------------------------
    // FETCH FILTERED FACETS
    // ----------------------------
    const bodyFiltered = JSON.stringify({ query: q, filter: filters, facet: facets });
    let facetResp = {};

    await fetch(`../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map${facetQueryString}`, {
        method: 'POST',
        headers,
        body: bodyFiltered
    })
        .then(resp => resp.json())
        .then(response => {
            if (response.facets) {
                Object.keys(response.facets)
                    .filter(f => f !== "count")
                    .forEach(f => {
                        const facet = response.facets[f];
                        if (!facetResp[f]) facetResp[f] = [];
                        facetResp[f].push(...sanitizeFacetBuckets(f, facet.buckets.map(bucket => ({
                            val: bucket.val + "",
                            count: bucket.count
                        }))));
                    });
            }

            // Also handle old Solr facet_counts (optional)
            if (response.facet_counts?.facet_queries) {
                const fqs = response.facet_counts.facet_queries;
                Object.keys(fqs).forEach(fq => {
                    const val = fq.split(":")[1];
                    if (!facetResp["cm_created"]) facetResp["cm_created"] = [];
                    facetResp["cm_created"].push({ val, count: fqs[fq] });
                });
            }
        });

    if (facetRefreshRequestId !== latestFacetRefreshRequestId) {
        return false;
    }

    FacetData = facetResp;

    // ----------------------------
    // FETCH UNFILTERED FACETS
    // ----------------------------
    const bodyUnfiltered = JSON.stringify({
        query: q,
        facet: facets,
        ...(campusFilteringActive ? { filter: filters } : {})
    });

    let allFacetResp = {};

    await fetch(`../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map${facetQueryString}`, {
        method: 'POST',
        headers,
        body: bodyUnfiltered
    })
        .then(resp => resp.json())
        .then(response => {
            if (response.facets) {
                Object.keys(response.facets)
                    .filter(f => f !== "count")
                    .forEach(f => {
                        const facet = response.facets[f];
                        if (!allFacetResp[f]) allFacetResp[f] = [];
                        allFacetResp[f].push(...sanitizeFacetBuckets(f, facet.buckets.map(bucket => ({
                            val: bucket.val + "",
                            count: bucket.count
                        }))));
                    });
            }

            if (response.facet_counts?.facet_queries) {
                const fqs = response.facet_counts.facet_queries;
                if (!allFacetResp["cm_created"]) allFacetResp["cm_created"] = [];
                Object.keys(fqs).forEach(fq => {
                    const val = fq.split(":")[1];
                    allFacetResp["cm_created"].push({ val, count: fqs[fq] });
                });
            }
        });

    if (facetRefreshRequestId !== latestFacetRefreshRequestId) {
        return false;
    }

    AllFacetData = allFacetResp;
    return true;
}

// Function used by CustomCheckPickers to fetch facet data
export async function getFacetPage(facetName, facetPageSize = DEFAULT_FACET_PAGE_SIZE) {
    const info = Field_Info || { fields: {} };
    const fields_info = info.fields || {};

    if (!fields_info[facetName]) {
        console.warn(`Skipping facet "${facetName}" because field info is missing.`);
        return;
    }

    facetOffsets[facetName] = facetOffsets[facetName] || 0;
    FacetData = FacetData || {};
    FacetData[facetName] = FacetData[facetName] || [];

    const {
        q,
        filters,
        headers,
        qf,
        facets,
        facetQueryString
    } = await buildFilteredFacetRequestContext({
        facetPageSize,
        facetOffsetsParam: { [facetName]: facetOffsets[facetName] },
        facetNames: [facetName]
    });

    if (!facets[facetName]) {
        return false;
    }

    const body = JSON.stringify({
        query: q,
        filter: filters,
        facet: facets
    });

    try {
        const resp = await fetch(
            `../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map${facetQueryString}`,
            { method: "POST", headers, body }
        ).then(r => r.json());

        let added = 0;

        if (resp.facets?.[facetName]?.buckets) {
            const buckets = sanitizeFacetBuckets(facetName, resp.facets[facetName].buckets.map(b => ({
                val: b.val + "",
                count: b.count
            })));

            if (buckets.length === 0) {
                // Nothing new returned → stop fetching
                return false;
            }

            // Efficient merge with Set (O(n))
            const existingVals = new Set(FacetData[facetName].map(i => i.val));
            buckets.forEach(b => {
                if (!existingVals.has(b.val)) {
                    FacetData[facetName].push(b);
                    existingVals.add(b.val);
                    added++;
                }
            });

            // Advance offset for lazy loading
            facetOffsets[facetName] += facetPageSize;
            return added > 0;
        }
    } catch (err) {
        console.error(`Failed to fetch facet "${facetName}":`, err);
    }
}

export async function getTypedFacetSearchContext(options = {}) {
    const {
        q,
        filters,
        headers,
        rawQf
    } = await buildFilteredFacetRequestContext(options);

    return {
        headers,
        filters,
        activeQuery: q,
        activeQueryQf: rawQf
    };
}

export async function fetchScopedFacetValues(options = {}) {
    const {
        facetNames = [],
        facetPageSize = DEFAULT_FACET_PAGE_SIZE,
        facetOffsetsParam = {},
        signal
    } = options;

    const {
        q,
        filters,
        headers,
        qf,
        facets,
        facetQueryString
    } = await buildFilteredFacetRequestContext({
        ...options,
        facetNames,
        facetPageSize,
        facetOffsetsParam
    });

    const requestedFacetNames = Object.keys(facets);
    const facetResp = requestedFacetNames.reduce((acc, facetName) => {
        acc[facetName] = [];
        return acc;
    }, {});

    const hasMore = requestedFacetNames.reduce((acc, facetName) => {
        acc[facetName] = false;
        return acc;
    }, {});

    const nextOffsets = requestedFacetNames.reduce((acc, facetName) => {
        acc[facetName] = facetOffsetsParam[facetName] || 0;
        return acc;
    }, {});

    if (requestedFacetNames.length === 0) {
        return {
            facetData: facetResp,
            hasMore,
            nextOffsets
        };
    }

    const body = JSON.stringify({
        query: q,
        filter: filters,
        facet: facets
    });

    const response = await fetch(
        `../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map${facetQueryString}`,
        {
            method: "POST",
            headers,
            body,
            signal
        }
    ).then(resp => resp.json());

    if (response.facets) {
        requestedFacetNames.forEach((facetName) => {
            const facet = response.facets?.[facetName];
            const buckets = Array.isArray(facet?.buckets) ? facet.buckets : [];

            facetResp[facetName] = sanitizeFacetBuckets(facetName, buckets.map((bucket) => ({
                val: bucket.val + "",
                count: bucket.count
            })));

            const requestedLimit = facets?.[facetName]?.limit || facetPageSize;
            hasMore[facetName] = buckets.length >= requestedLimit;
            nextOffsets[facetName] = (facetOffsetsParam[facetName] || 0) + buckets.length;
        });
    }

    if (response.facet_counts?.facet_queries) {
        const facetQueries = response.facet_counts.facet_queries;

        Object.keys(facetQueries)
            .filter(facetQuery => facetQuery.indexOf(":") > 0)
            .forEach((facetQuery) => {
                const splits = facetQuery.split(":");
                const facetFieldParts = splits[0];
                const facetField = facetFieldParts.replace(/{!ex=[^}]+}/g, "");
                const val = splits[1];

                if (!facetResp[facetField]) {
                    facetResp[facetField] = [];
                }

                facetResp[facetField].push({
                    val,
                    count: facetQueries[facetQuery]
                });
            });
    }

    return {
        facetData: facetResp,
        hasMore,
        nextOffsets
    };
}

export async function fetchScopedFacetValueSearch({
    facetName,
    facetPageSize = DEFAULT_FACET_PAGE_SIZE,
    facetOffset = 0,
    signal,
    ...contextOptions
} = {}) {
    if (!facetName) {
        return {
            buckets: [],
            hasMore: false,
            nextOffset: facetOffset
        };
    }

    // Keep matching in the caller. JSON facet prefix is term/case-sensitive,
    // while GallerySearch typed search is case-insensitive.
    const { facetData, hasMore, nextOffsets } = await fetchScopedFacetValues({
        ...contextOptions,
        facetNames: [facetName],
        facetPageSize,
        facetOffsetsParam: { [facetName]: facetOffset },
        signal
    });

    return {
        buckets: Array.isArray(facetData?.[facetName]) ? facetData[facetName] : [],
        hasMore: !!hasMore?.[facetName],
        nextOffset: nextOffsets?.[facetName] ?? facetOffset
    };
}

async function buildFilteredFacetRequestContext({
    filterQuery,
    qconfig,
    type,
    bin_and_curation,
    skipLoadedNodeExclusion = false,
    excludedFilterFields = [],
    excludedFilterRules = [],
    facetPageSize = DEFAULT_FACET_PAGE_SIZE,
    facetOffsetsParam = {},
    facetPrefixesParam = {},
    facetNames = null,
    viewOverride = null
} = {}) {
    let config = getConfig;
    const rawView = viewOverride || getView() || {};
    const view = {
        ...rawView,
        filters: Array.isArray(rawView.filters)
            ? rawView.filters.filter(filter => !excludedFilterFields.includes(filter.field_name))
            : [],
        facets: Array.isArray(rawView.facets) ? [...rawView.facets] : [],
        filter_rules: Array.isArray(rawView.filter_rules)
            ? rawView.filter_rules.filter(rule => !excludedFilterRules.includes(rule))
            : []
    };

    if (qconfig && type && type !== "classify") {
        config = qconfig;
    }

    if (!skipLoadedNodeExclusion) {
        if (bin_and_curation && bin_and_curation.length > 0) {
            view.filters.push({ field_name: "id", value: [...bin_and_curation], inverse: true });
        } else {
            const bin = Array.isArray(MyBin) ? [...MyBin] : [];
            let curation = Array.isArray(Curation) ? [...Curation] : [];

            if ((!type || !["bin", "classify", "upload", "album"].includes(type)) && curation.length === 0) {
                const albumNodes = await getAlbumNodes(1);
                if (albumNodes) {
                    curation = curation.concat(albumNodes);
                }
            }

            const loaded = [...bin, ...curation];
            if (loaded.length > 0) {
                view.filters.push({ field_name: "id", value: loaded, inverse: true });
            }
        }
    }

    const info = Field_Info;
    const fields_info = info.fields;

    const query = view.query ?? "";
    let q = query === "" ? "*:*" : query.indexOf(":") !== -1 ? query : sanitiseQuery(query);

    let login = getLogin();
    let campusFilteringActive = false;
    if (login) {
        if (!checkAcl(login.roles, config.acls, "ADMIN") && !["album", "favourite", "upload"].includes(type)) {
            if (checkMultiCampus()) {
                campusFilteringActive = true;
                const campus = getMultiCampuslist();
                const campusFilters = campus.map(c => `sb_uploaderCampus:"${c}" OR sb_studentCampus:"${c}"`).join(" OR ");
                const scopedQuery = filterQuery || q;
                q = !scopedQuery || scopedQuery === "*:*" || scopedQuery === "*"
                    ? `(${campusFilters})`
                    : `(${scopedQuery}) AND (${campusFilters})`;
            } else if (filterQuery) {
                q = filterQuery;
            }
        } else if (filterQuery) {
            q = filterQuery;
        }
    } else if (filterQuery) {
        q = filterQuery;
    }

    const requestedFacets = Array.isArray(facetNames) && facetNames.length > 0
        ? facetNames
        : (view.facets || []);

    const facets = requestedFacets
        .filter(f => fields_info[f] !== undefined && fields_info[f].type !== "date")
        .reduce((acc, val) => {
            acc[val] = {
                type: "terms",
                field: val,
                sort: val === "sb_year" ? "index desc" : "index asc",
                domain: { excludeTags: val },
                limit: facetPageSize,
                offset: facetOffsetsParam[val] || 0
            };

            if (facetPrefixesParam[val]) {
                acc[val].prefix = facetPrefixesParam[val];
            }

            return acc;
        }, {});

    const date_type_fields = requestedFacets
        .filter(f => fields_info[f] && fields_info[f].type === "date" && f === "cm_created");

    const facet_query_field = date_type_fields.flatMap(field => {
        const encodedField = encodeURIComponent(field);
        return [
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1DAY TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-7DAYS TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1MONTH TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1YEAR TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[* TO NOW-1YEAR]`
        ];
    }).join("&");

    let filters = [config.default_filter];
    const applied_filter_rules = [];
    const filter_rules = view.filter_rules || [];

    filter_rules.forEach(rule => {
        if (config?.filter_rules?.[rule]) {
            applied_filter_rules.push(config.filter_rules[rule]);
        }
    });

    filters = filters.concat(
        view.filters
            .filter(f => f.field_name !== "Advanced")
            .map(f => filterToString(f, info.fields))
            .concat(applied_filter_rules.map(f => filterToString(f, info.fields)))
    );

    filters = filters.concat(
        view.filters
            .filter(f => f.field_name === "Advanced")
            .map(f => Array.isArray(f.value) ? f.value.join(" ") : f.value)
    );

    const rawQf = getQueryFields(config, info);

    const headers = {
        'Content-Type': 'application/json',
        'Semabench-Token': getToken(),
        'Cache-Control': 'max-age=0'
    };

    return {
        q,
        filters,
        headers,
        qf: encodeURIComponent(rawQf),
        rawQf,
        facets,
        facetQueryString: facet_query_field ? `&${facet_query_field}` : "",
        campusFilteringActive
    };
}

// Gets called to update search suggestion in dropdown after a suer starts typing
export async function updateSearchSuggestions() {
    let config = getConfig;
    let view = getView()
    let query = config.view.query.toLowerCase();

    let token = getToken();
    let headers = { 'Content-Type': 'application/json', "Semabench-Token": token, "Cache-Control": "max-age=0" };

    let filters = [config.default_filter];

    let info = Field_Info

    let body = JSON.stringify({
        filter: filters
    })

    filters = filters.concat(view.filters
        .filter(filter => filter.field_name !== "Advanced")
        .map(filter => filterToString(filter, info.fields)));

    if (query === "*:*") {
        query = "";
    }

    await fetch(`../api/v1/repo/s/semabench/query?q=*:*&fl=id&json.nl=map&rows=0&facet.limit=10&facet=true&facet.mincount=1&facet.prefix=${query}&facet.field=suggest`, {
        method: "POST",
        headers,
        body
    }).then(resp => {
        return resp.json()
    })
        .then(result => {
            let facets = result.facet_counts.facet_fields
            let suggest = facets["suggest"]


            let suggestions = []
            if (suggest !== undefined && suggest !== null) {
                suggestions = Object.keys(suggest);
            }

            // config.suggestions = suggestions
            getConfig.suggestions = suggestions
            // sessionStorage.setItem("C", JSON.stringify(config));
        }).catch(error => {

        })
}

// Loads the fields and data of each results
export async function loadingFields(response, type) {
    if (type === "tag") {
        Query.docs = response
        return Query
    }
    let docs = [];
    let num_found = 0;
    let facets = {};
    let q = Query;
    if (q !== undefined && q !== null) {
        Query.advanced_query = q.advanced_query;
    }

    if (response && response.response) {
        if (response.response.docs) {
            docs = response.response.docs;
        }
        if (response.response.numFound) {
            num_found = response.response.numFound;
        }

        // to receive the facet counts
        // if (response.facet_counts) {

        //     if (response.facet_counts.facet_fields) {
        //         facets = response.facet_counts.facet_fields;
        //     }

        //     if (response.facet_counts.facet_queries) {
        //         let facet_queries = response.facet_counts.facet_queries;
        //         Object.keys(facet_queries)
        //             .filter(facet_query => facet_query.indexOf(":") > 0)
        //             .forEach(facet_query => {
        //                 let splits = facet_query.split(":");
        //                 let facet_field_parts = splits[0];

        //                 //Filter out our facet tag
        //                 let facet_field = facet_field_parts.replace(/{!ex=[^}]+}/g, "");

        //                 let val = splits[1];
        //                 let count = facet_queries[facet_query];

        //                 if (!facets[facet_field]) {
        //                     facets[facet_field] = [];
        //                 }

        //                 facets[facet_field].push({ val, count });
        //             });
        //     }
        // }

        if (response.facets && ["classify", "album"].includes(type)) {

            let facet_resp = response.facets;

            Object.keys(facet_resp).filter(val => val !== "count")
                .map(facet_field => {
                    let facet = facet_resp[facet_field];

                    if (!facets[facet_field]) {
                        facets[facet_field] = [];
                    }

                    facet.buckets.forEach((bucket) => {
                        facets[facet_field].push({
                            val: bucket.val + "",
                            count: bucket.count
                        });
                    });
                    return facet
                });
            FacetData = facets
        }

        Query.docs = docs;
        Query.num_found = num_found;
    }
    return Query;
}

// Function for getting the profiles based on the profile types and max row of profiles needed
export async function getProfileQuery(rows, profileTypes) {

    // Loads all the config, info and currenty query
    let config = getConfig;

    let view = getView();
    let info = Field_Info;

    // Loads the current saved query
    let current_q = Query;
    if (current_q === undefined || current_q === null) {
        current_q = initialState
    }


    // adds the fild lists into the URL
    let fl = encodeURIComponent(fieldList(info.fields).join(","));

    // Gets the Solr query info
    let query = view.query;
    let q = query === "" ? "*:*" : query.indexOf(":") !== -1 ? query : sanitiseQuery(query);

    let filters = [];

    let applied_filter_rules = [];

    let filter_rules = [];

    // Creates three filters as we need only the profile type and it being a profile
    view.filters = [];
    view.filters.push({ field_name: "sb_profileType", value: profileTypes, inverse: false })
    view.filters.push({ field_name: "sb_adminStatus", value: ["Profile"], inverse: false })
    view.filters.push({ field_name: "sb_adminStatus", value: ["Reference Point"], inverse: true })

    filter_rules.forEach(filter_rule => {
        if (config.filter_rules[filter_rule] !== undefined && config.filter_rules[filter_rule] !== null) {
            applied_filter_rules.push(config.filter_rules[filter_rule]);
        }
    });

    let sort = view.sort.field + " " + view.sort.direction;

    let fields_info = info.fields;
    let query_facets = view.facets;

    // Creates the facet query based on the facets added.
    let facets = query_facets.filter(facet => fields_info[facet] !== undefined).filter(facet => fields_info[facet].type !== "date");

    let date_type_fields = query_facets.filter(facet => fields_info[facet] !== undefined).filter(facet => fields_info[facet].type === "date");


    // let facet_query_field = date_type_fields.map(encodeURIComponent).map(field =>
    //     [field + ":[NOW-1DAY TO NOW]", field + ":[NOW-7DAYS TO NOW]", field + ":[NOW-1MONTH TO NOW]", field + ":[NOW-1YEAR TO NOW]", field + ":[* TO NOW-1YEAR]"].map(query => `facet.query={!ex=${field}}${query}`).join("&")
    // ).join("&");

    let facet_query_field = date_type_fields.flatMap(field => {
        let encodedField = encodeURIComponent(field);
        return [
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1DAY TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-7DAYS TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1MONTH TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1YEAR TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[* TO NOW-1YEAR]`
        ];
    }).join("&");

    filters = filters.concat(view.filters
        .filter(filter => filter.field_name !== "Advanced")
        .map(filter => filterToString(filter, info.fields)).concat(applied_filter_rules.map(filter => filterToString(filter, info.fields))));

    let facetOptions = "facet.limit=" + (FACET_LIMIT + 1);

    filters = filters.concat(view.filters.filter(filter => filter.field_name === "Advanced").map(filter => isArray(filter.value) ? filter.value.join(" ") : filter.value));

    // Options of setting path starts with
    if (facets.indexOf("path_starts_with") !== -1) {
        let facet_field = view.filters.find(filter => filter.field_name === "path_starts_with");

        let prefix = facet_field !== undefined ? (isArray(facet_field.value) ? facet_field.value.join(" ") : facet_field.value) : config.path_strip;

        facetOptions += "&f.path_starts_with.facet.limit=1000";
        facetOptions += "&f.path_starts_with.facet.mincount=0";
        facetOptions += "&f.path_starts_with.facet.sort=index";
        facetOptions += "&f.path_starts_with.facet.prefix=" + encodeURIComponent(prefix);
    }

    let token = getToken();
    let headers = { 'Content-Type': 'application/json', "Semabench-Token": token, "Cache-Control": "max-age=0" };

    let qf = encodeURIComponent(getQueryFields(config, info));
    let facet = {};

    facets.forEach(val => {

        let limit = FACET_LIMIT + 1;
        facet[val] = {
            type: "terms",
            field: val,
            sort: val === "sb_year" ? "index desc" : undefined,
            domain: {
                excludeTags: val
            },
            limit,
        }
    })

    facet_query_field = facet_query_field === "" ? "" : "&" + facet_query_field;

    let body = JSON.stringify({
        query: q,
        filter: filters,
        facet: facet
    })

    body = JSON.stringify({
        "query": "*:*",
        "filter": filters
    })

    let val = undefined
    return await fetch(`../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&sort=${sort}&fl=${fl}&rows=${rows}&facet=true&facet.mincount=1&${facetOptions}` + facet_query_field, {
        method: "POST",
        headers,
        body
    }).then(resp => resp.json())
        .then(async re => {
            val = re;

            return await val;
        })
        .catch(error => {
            // toaster.push(<Message type='error' showIcon closable>{error}</Message>);
        })
}

// Function for getting the profiles based on the profile types and max row of profiles needed
export async function getImageCount(id, type) {
    let token = getToken();
    let getBin = [...MyBin]
    getBin.push(id);
    let headers = { 'Content-Type': 'application/json', "Semabench-Token": token, "Cache-Control": "max-age=0" };

    let campus = getMultiCampuslist();

    //create new query with uploaderCampus and update the query
    let new_q = ""
    if (type === "MultiCampus") {
        for (let y = 0; y < campus.length; y++) {
            if (y + 1 === campus.length) {
                new_q += "sb_uploaderCampus:\"" + campus[y] + "\""
            } else {
                new_q += "sb_uploaderCampus:\"" + campus[y] + "\" OR "
            }

        }
    } else {
        new_q = "*:*"
    }

    let body = JSON.stringify({
        query: 'sb_relatedID:"' + id + '" AND (*:* NOT id:"' + getBin.join(' OR ') + '") AND (' + new_q + ")",
        filter: ["{!tag=id}-id:(" + getBin.join(" OR ") + ")",
            "{!tag=sb_adminStatus}-sb_adminStatus:(\"Profile\")",
            "{!tag=sb_adminStatus}-sb_adminStatus:(\"Reference Point\")"]
    })
    return await fetch('../../api/v1/repo/s/semabench/query?q=*:*&rows=5000', {
        method: 'POST',
        headers: headers,
        body: body
    }).then(resp => resp.json())
        .then(async response => {
            if (response.response !== undefined && response.response !== null) {
                return response.response.docs.length
            }
        });
}

// Does a query search to get all the facets, regardless of 200 to fill out search drop downs
export async function getAllFacets() {
    let config = getConfig;
    let view = getView();
    view.filters = []

    // loads the nodes that are within the bin
    let bin = MyBin;

    // if not accessing upload, bin or curation. Will add the curation and bin nodes to a filter to ignore them on lookup
    let curation = Curation || []
    if (curation.length === 0) {
        const albumNodes = await getAlbumNodes(1);
        if (albumNodes) {
            albumNodes?.forEach(doc => curation.push(doc));
        }
    }

    let loaded_bin_and_curation = [...bin, ...curation]

    // if accessing the bin, does a search on only the bin nodes
    if (loaded_bin_and_curation.length > 0) {
        view.filters.push({ field_name: "id", value: loaded_bin_and_curation, inverse: true });
    }

    let info = Field_Info;
    let fields_info = info.fields;

    let facet = {};
    let token = getToken();

    let headers = { 'Content-Type': 'application/json', "Semabench-Token": token, "Cache-Control": "max-age=0" };

    let q = "*:*"

    let query_facets = view.facets;

    // Creates the facet query based on the facets added.
    let facets = query_facets.filter(facet => fields_info[facet] !== undefined).filter(facet => fields_info[facet].type !== "date");

    let date_type_fields = query_facets.filter(facet => fields_info[facet] !== undefined).filter(facet => facet === "cm_created" && fields_info[facet].type === "date");

    // let facet_query_field = date_type_fields.map(encodeURIComponent).map(field =>
    //     [field + ":[NOW-1DAY TO NOW]", field + ":[NOW-7DAYS TO NOW]", field + ":[NOW-1MONTH TO NOW]", field + ":[NOW-1YEAR TO NOW]", field + ":[* TO NOW-1YEAR]"].map(query => `facet.query={!ex=${field}}${query}`).join("&")
    // ).join("&");

    let facet_query_field = date_type_fields.flatMap(field => {
        let encodedField = encodeURIComponent(field);
        return [
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1DAY TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-7DAYS TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1MONTH TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[NOW-1YEAR TO NOW]`,
            `facet.query={!ex=${encodedField}}${encodedField}:[* TO NOW-1YEAR]`
        ];
    }).join("&");

    facets.forEach(val => {

        let limit = FACET_LIMIT + 1;
        facet[val] = {
            type: "terms",
            field: val,
            sort: val === "sb_year" ? "index desc" : undefined,
            domain: {
                excludeTags: val
            },
            limit,
        }
    })

    let body;

    let filters = [config.default_filter];

    let applied_filter_rules = [];


    let filter_rules = view.filter_rules || [];

    filter_rules.forEach(filter_rule => {
        if (config?.filter_rules !== undefined && config?.filter_rules !== null) {
            if (config.filter_rules[filter_rule] !== undefined && config.filter_rules[filter_rule] !== null) {
                applied_filter_rules.push(config.filter_rules[filter_rule]);
            }
        }
    });

    filters = filters.concat(view.filters
        .filter(filter => filter.field_name !== "Advanced")
        .map(filter => filterToString(filter, info.fields)).concat(applied_filter_rules.map(filter => filterToString(filter, info.fields))));

    filters = filters.concat(view.filters.filter(filter => filter.field_name === "Advanced").map(filter => isArray(filter.value) ? filter.value.join(" ") : filter.value));

    //applying solr query based on the identified campus
    let login = getLogin();
    if (login !== undefined && login !== null) {
        if (!checkAcl(login.roles, config.acls, "ADMIN")) {
            //update the solr query
            if (checkMultiCampus()) {
                let campus = getMultiCampuslist()
                let new_q = ""
                for (let y = 0; y < campus.length; y++) {
                    let part = `sb_uploaderCampus:"${campus[y]}" OR sb_studentCampus:"${campus[y]}"`;
                    if (y + 1 === campus.length) {
                        new_q += part;
                    } else {
                        new_q += part + " OR ";
                    }
                }
                q = new_q
            }
        }
    }

    if (filters !== undefined && filters !== null) {
        body = JSON.stringify({
            query: q,
            filter: filters,
            facet: facet
        })
    } else {
        body = JSON.stringify({
            query: q
        })
    }

    let qf = encodeURIComponent(getQueryFields(config, info));

    let facetResp = {};
    facet_query_field = facet_query_field === "" ? "" : "&" + facet_query_field;

    await fetch(`../api/v1/repo/s/semabench/query?q.op=AND&omitHeader=true&defType=edismax&qf=${qf}&pf=${qf}&df=suggest&indent=true&sow=false&wt=json&json.nl=map&facet=true&rows=0&json.nl=map` + facet_query_field, {
        method: 'POST',
        headers: headers,
        body: body
    }).then(resp => resp.json())
        .then(response => {
            // Depedns on the results if there were filters or not
            if (response.facet_counts) {

                if (response.facet_counts.facet_fields) {
                    facetResp = response.facet_counts.facet_fields;
                }

                if (response.facet_counts.facet_queries) {
                    let facet_queries = response.facet_counts.facet_queries;
                    Object.keys(facet_queries)
                        .filter(facet_query => facet_query.indexOf(":") > 0)
                        .forEach(facet_query => {
                            let splits = facet_query.split(":");
                            let facet_field_parts = splits[0];

                            //Filter out our facet tag
                            let facet_field = facet_field_parts.replace(/{!ex=[^}]+}/g, "");

                            let val = splits[1];
                            let count = facet_queries[facet_query];

                            if (!facetResp[facet_field]) {
                                facetResp[facet_field] = [];
                            }

                            facetResp[facet_field].push({ val, count });
                        });
                }
            }


            if (response.facets) {
                let facet_resp = response.facets;
                Object.keys(facet_resp).filter(val => val !== "count")
                    .map(facet_field => {
                        let facet = facet_resp[facet_field];

                        if (!facetResp[facet_field]) {
                            facetResp[facet_field] = [];
                        }

                        facetResp[facet_field].push(...sanitizeFacetBuckets(facet_field, facet.buckets.map((bucket) => ({
                            val: bucket.val + "",
                            count: bucket.count
                        }))));
                        return facet
                    });
            }
        })

    if (Object.keys(facetResp).length !== 0) {

        AllFacetData = facetResp
    }
}
